var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Film-movie"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BG",
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2422 7.25V6C20.2422 5.31 19.6822 4.75 18.9922 4.75H17.2422V7.25H20.2422ZM20.2422 8.75H12.7422V15.25H20.2422V8.75ZM4.99219 19.25H6.74219V16.75H3.74219V18C3.74219 18.69 4.30219 19.25 4.99219 19.25ZM8.24219 16.75H11.2422V19.25H8.24219V16.75ZM15.7422 16.75H12.7422V19.25H15.7422V16.75ZM20.2422 18V16.75H17.2422V19.25H18.9922C19.6822 19.25 20.2422 18.69 20.2422 18ZM15.7422 4.75H12.7422V7.25H15.7422V4.75ZM3.74219 8.75H11.2422V15.25H3.74219V8.75ZM6.74219 4.75V7.25H3.74219V6C3.74219 5.31 4.30219 4.75 4.99219 4.75H6.74219ZM8.24219 4.75H11.2422V7.25H8.24219V4.75Z",
    fill: "#C07600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 4V20M16.5 20V16M16.5 8V4M7.5 20V16M7.5 8V4M21 8H3M21 16H3M3 18V6C3 4.9 3.9 4 5 4H19C20.1 4 21 4.9 21 6V18C21 19.1 20.1 20 19 20H5C3.9 20 3 19.1 3 18Z",
    stroke: "#C07600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilm);
export default __webpack_public_path__ + "static/media/Film.0065cecec97278c04fe4f09faceb6f1b.svg";
export { ForwardRef as ReactComponent };